import { useTranslation } from 'react-i18next';
import { TrendingUp } from 'lucide-react';
import { GlassCard } from '@/components/ui/GlassCard';
import { cn } from '@/lib/cn';

interface KpiCardProps {
  labelKey: string;
  value: number;
  delta: string;
  tone: 'primary' | 'cyan' | 'gold' | 'warning';
  index: number;
}

const accent: Record<KpiCardProps['tone'], string> = {
  primary: 'from-primary/30 to-primary/0 text-primary',
  cyan: 'from-cyan/30 to-cyan/0 text-cyan',
  gold: 'from-gold/30 to-gold/0 text-gold',
  warning: 'from-warning/30 to-warning/0 text-warning',
};

export function KpiCard({ labelKey, value, delta, tone, index }: KpiCardProps) {
  const { t } = useTranslation();
  return (
    <GlassCard interactive delay={index * 0.06} className="relative overflow-hidden">
      <div className={cn('absolute -right-6 -top-6 h-24 w-24 rounded-full bg-gradient-to-br blur-xl', accent[tone])} />
      <p className="text-sm text-muted-foreground">{t(`dashboard.kpi.${labelKey}`)}</p>
      <div className="mt-2 flex items-end justify-between">
        <span className="font-display text-3xl font-bold tabular-nums">{value.toLocaleString()}</span>
        <span className={cn('flex items-center gap-1 text-xs font-medium', accent[tone].split(' ').pop())}>
          <TrendingUp className="h-3.5 w-3.5" />
          {delta}
        </span>
      </div>
    </GlassCard>
  );
}
